module.exports = __webpack_public_path__ + "img/sunset.63317db9.jpg";